import Message from './message.jsx'
import './message.css'
export default Message;